import { Box, Container, Divider, Paper, Typography } from '@mui/material';
import moment from 'moment';
import { useContext } from 'react';
import { ColorModeContext } from '../..';
import SCGLogoColor from '../../assets/SCGC_Logo_Color.png';
import SCGLogoWhite from '../../assets/SCGC_Logo_White.png';

export default function Footer() {
  const { mode } = useContext(ColorModeContext);
  return (
    <>
      <Divider />
      <Paper
        elevation={0}
        square
        sx={(theme) => ({
          py: 3,
          boxShadow: `0 50vh 0 50vh ${theme.palette.background.paper}`,
          height: '100%'
        })}
      >
        <Container>
          {/* <Divider sx={{ my: 4 }} /> //TODO: Add more information later*/}
          <Box display="flex" alignItems="center">
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: '120%', mr: 1, flexGrow: 1 }}
            >
              ©{moment().year()} All Rights Reserved,{' '}
              <Box
                component="span"
                sx={{
                  fontFamily: 'Comfortaa',
                  letterSpacing: -1,
                  fontWeight: 700
                }}
              >
                backspace
              </Box>
            </Typography>
            <Box
              component="a"
              href="https://www.scgchemicals.com"
              target="_blank"
              display="flex"
              alignItems="center"
            >
              <img
                src={mode === 'light' ? SCGLogoColor : SCGLogoWhite}
                alt="SCGC Logo"
                style={{ width: 120 }}
              />
            </Box>
          </Box>
        </Container>
      </Paper>
    </>
  );
}
